export default {
  getProjectFullLabel(project) {
    let projectLabel = "";
    projectLabel += project.projectId || "";
    projectLabel += project.projectId && project.name ? " - " : "";
    projectLabel += project.name || "";
    return projectLabel;
  }
}